import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { OldArrowDown } from '@shared/assets/icons';
import { Member } from '../model/bank.types';
interface LastUsedBankCardProps {
  lastUsedBank: Member;
}
const LastUsedBankCard: FC<LastUsedBankCardProps> = ({
  lastUsedBank
}) => {
  const handleCardClick = () => {
    localStorage.setItem('sbpMember', lastUsedBank.name);
    window.location.href = lastUsedBank.url;
  };
  return <CardWrapper onClick={handleCardClick}>
      {/* <StyledImage src={lastUsedBank.logo} alt="Логотип" width={52} height={52} /> */}
      <Text>{lastUsedBank.name}</Text>
      <ArrowWrapper>
        <OldArrowDown />
      </ArrowWrapper>
    </CardWrapper>;
};
export default LastUsedBankCard;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const CardWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "CardWrapper",
  class: "c1sn3091",
  propsAsIs: false,
  vars: {
    "c1sn3091-0": [_exp()]
  }
}));

// const StyledImage = withTheme(styled(Image)<ThemeProps>`
//   border-radius: 16px;
//   overflow: hidden;
//   display: inline-block;
//   height: auto;
// `)

const ArrowWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ArrowWrapper",
  class: "ae2xbvk",
  propsAsIs: false
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "twbn2jf",
  propsAsIs: false,
  vars: {
    "twbn2jf-0": [_exp2()],
    "twbn2jf-1": [_exp3(), "px"],
    "twbn2jf-2": [_exp4()],
    "twbn2jf-3": [_exp5(), "px"],
    "twbn2jf-4": [_exp6()]
  }
}));

require("./LastUsedBankCard.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./LastUsedBankCard.tsx");